/**
 * customizing by getintent dev team
 */

// Endless tree structured UL > LI > UL

$.extend($.expr[":"], {
    "containsIN": function (elem, i, match, array) {
        return (elem.textContent || elem.innerText || "").toLowerCase().indexOf((match[3] || "").toLowerCase()) >= 0;
    }
});

var treefilter = function (el, options) {

    var disableCalcSelected = false;

    var defaults = {
        offsetLeft: 20, // left offset for each level
        searcher: null, // search input field
        info: null,
        expanded: false, // if true, your list will be show with expanded.
        multiselect: false, // multiselect.
        selectAllMax: 30
    };

    // Public Variables
    var plugin = this;
    var status = []; // save folder status for "var memory"

    plugin.settings = {};

    // Main Function
    var init = function () {

        plugin.settings = $.extend({}, defaults, options);
        plugin.el = el;

        // set class names to tags
        el.addClass("tf-tree");
        el.find("li").addClass("tf-child-true");
        el.find("li").css("padding-left", plugin.settings.offsetLeft);
        el.find("li div:only-child").parent().removeClass("tf-child-true");
        el.find("li div:only-child").parent().addClass("tf-child-false");

        // if the list has a checkbox, block event bubbling.
        el.find("input[type=checkbox]").click(function (e) {
            e.stopPropagation();
        });

        //set click event.
        el.find("li.tf-child-true").children("div").off("click.treefilter").on("click.treefilter", function (e) {
            if (e.metaKey || e.ctrlKey) {
                if ($(this).parent().hasClass("tf-open")) {
                    $(this).parent().find("li.tf-child-true").removeClass("tf-open");
                } else {
                    $(this).parent().find("li.tf-child-true").addClass("tf-open");
                }
            }
            $(this).parent().toggleClass("tf-open");
        });


        // toggle effect when multiselect enabled.
        el.find("li.tf-child-false").off("click.treefilter").on("click.treefilter", function () {
            if (plugin.settings.multiselect != true) {
                el.find("li.tf-selected").removeClass("tf-selected");
            }
            // toggle checkboxes state
            var self = $(this);
            self.toggleClass("tf-selected");
            var checkbox = self.find("input[type='checkbox']");
            if (self.hasClass("tf-selected")) {
                checkbox.attr('checked', 'checked');
            } else {
                checkbox.removeAttr('checked');
            }

            calcSelected(el);
        });

        el.find(".tf-select-toggle").off("click.treefilter").on("click.treefilter", function (e) {
            e.stopPropagation();
            disableCalcSelected = true;
            var node = $(this).parent().parent(),
                collection;

            if($(this).parent(".tf-group-display").hasClass("tf-selected-display")) {
                collection = node.find('li.tf-child-false.tf-selected');
            } else {
                collection = node.find('li.tf-child-false:not(.tf-selected)');
            }
            

            if (node.hasClass('tf-search-result')) {
                collection.filter('.tf-search-result').click();
            } else {
                collection.click();
            }

            disableCalcSelected = false;
            calcSelected(el);
        });

        // select all elements in tree
        el.find(".tf-select-all").off("click.treefilter").on("click.treefilter", function (e) {
            e.stopPropagation();
            disableCalcSelected = true;
            var node = $(this).closest('li'),
                collection = node.find('li.tf-child-false:not(.tf-selected)');

            if (node.hasClass('tf-search-result')) {
                collection.filter('.tf-search-result').click();
            } else {
                collection.click();
            }

            disableCalcSelected = false;
            calcSelected(el);
        });

        // unselect all elements in tree
        el.find(".tf-unselect-all").off("click.treefilter").on("click.treefilter", function (e) {
            e.stopPropagation();
            disableCalcSelected = true;
            var node = $(this).closest('li'),
                collection = node.find('li.tf-child-false.tf-selected');

            if (node.hasClass('tf-search-result')) {
                collection.filter('.tf-search-result').click();
            } else {
                collection.click();
            }

            disableCalcSelected = false;
            calcSelected(el);
        });

        $(plugin.settings.info).off("click.treefilter").on("click.treefilter", '.tf-remove', function (e) {
            var self = $(this),
                value = self.attr('data-remove-value');

            el.find('li.tf-child-false[data-value="' + value + '"]').click();
            e.stopPropagation();
        });

        if (plugin.settings.searcher) {
            searcher();
        }

        calcSelected(el);
    };

    // PUBLIC METHOD
    plugin.openAll = function () {
        plugin.el.find("li.tf-child-true").parent().addClass("tf-open");
    };
    plugin.closeAll = function () {
        plugin.el.find("li.tf-child-true").parent().removeClass("tf-open");
    };

    // PRIVATE FUNCTION
    // fired when type on search input field.
    var searcher = function () {
        $(plugin.settings.searcher).keyup(function () {
            if (!$(this).val().length) {
                plugin.el.removeClass("tf-search-result");
                plugin.el.find(".tf-search-result").removeClass("tf-search-result");
                memory("out", status);
            } else {

                // if something was opened close it
                plugin.closeAll();
                plugin.el.find("li.tf-open").removeClass("tf-open");
                plugin.el.find("li.tf-search-result").removeClass("tf-search-result");

                // open what we have searched
                plugin.el.find("li:containsIN('" + $(this).val() + "')").addClass("tf-search-result").addClass('tf-open');
                plugin.el.find("li.tf-search-result").parent().addClass("tf-search-result");
            }
        });
        $(plugin.settings.searcher).keydown(function () {
            if ($(this).val().length == 0) {
                memory("in", status);
            }
        });
    };

    // calculate selected elements in parent el
    var calcSelected = function (el) {

        if (disableCalcSelected) {
            return false;
        }

        var infoContainer = $(plugin.settings.info).find('.tf-badges'),
            collection = el.find('li.tf-child-true');

        var div = collection.children('div');
        div.removeClass('tf-selected-display');


        // It is the big cycle but the performance hardly ever depend on it
        collection.each(function () {

            var node = $(this),
                all = node.find('li'),
                div = node.children('div'),
                allCount = all.length;

            div.toggleClass('tf-group-display', allCount <= plugin.settings.selectAllMax);

            if (node.find('li.tf-selected:first').length) {

                var allSelected = all.filter('.tf-selected'),
                    selectedCount = allSelected.length;

                div.find('.tf-selected-count').html(selectedCount);
                div.toggleClass('tf-selected-display', selectedCount > 0);
            }
        });

        var selectedCollection = el.find('.tf-selected');

        infoContainer.empty();
        selectedCollection.each(function () {
            infoContainer.append('<span class="label label-badge">' + $(this).attr('data-name') + ' <i data-remove-value="' + $(this).attr('data-value') + '" class="tf-remove tf-remove fa fa-close opacity-dynamic"></i></span> ');
        });

        $(plugin.settings.info).find('.tf-all-selected-count').html(selectedCollection.length);
    };

    // save current status of folder
    // action : string "in" / "out"
    // array : array that saves current status
    // list : el
    var memory = function (action) {
        if (action == "in") {
            status = [];
            plugin.el.find("li").each(function () {
                status.push($(this).hasClass("tf-open"));
            });
        } else if (action == "out") {
            plugin.el.find("li").each(function (i) {
                if (status[i]) {
                    $(this).addClass("tf-open");
                } else {
                    $(this).removeClass("tf-open");
                }
            });
        }
    };

    init();
};